module.exports = __webpack_public_path__ + "img/myposition_wf_손흥민.f173ae49.png";